import React, { useState, useEffect } from "react";
import CheckoutPoduct from "./CheckoutProduct";
import "./Payment.css";
import { Link, useHistory, history } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import CurrencyFormat from "react-currency-format";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { getCartTotal } from "./reducer";
import axios from "./axios";
import {db} from "./firebase"

function Payment() {
  const [{ cart, user }, dispatch] = useStateValue();
  const history = useHistory();

  const [disabled, setDisabled] = useState(true);
  const [error, setError] = useState(null);
  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState("");
  const [clientSecret, setClientSecret] = useState("")

  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    //generate the special stripe secret which will be used to charge the client
    const getClientSecret = async () => {
      
        const response = await axios({
            method: 'post',
            //stripe expexts the total in a currency's subunites
            url: `/payments/create?total=${getCartTotal(cart) * 100}`
        })
        setClientSecret(response.data.clientSecret)
    };

    getClientSecret();
  }, [cart]);

  console.log('STOOOOPPPP IIIITTTTTT', clientSecret);

  const handleSubmit = async (event) => {
    //stripe work....
    event.preventDefault();
    setProcessing(true);

     const payload = await stripe.confirmCardPayment(clientSecret, {
         payment_method:{
             card:elements.getElement(CardElement)
         }
     }).then(({paymentIntent})=>{

      // paymentIntent = payment confirmation
        
      db.collection('users')
      .doc(user?.uid)
      .collection('orders')
      .doc(paymentIntent.id)
      .set({
        cart:cart,
        amount: paymentIntent.amount,
        created: paymentIntent.created,
      })


         setSucceeded(true);
         setError(null);
         setProcessing(false) 


         dispatch({
           type: 'EMPTY_CART'
         })


         history.replace('/orders')
     }) 
  };

  const handleChange = e => {
    //listen to card changes
    setDisabled(e.empty);
    setError(e.error ? e.error.message : "");
  };

  return (
    <div className="payment">
      <div className="payment__container">
        {/* delivery address */}
        <Link to="/checkout">{cart?.length} Items</Link>
        {/* review Items  */}
        {/* payment method */}

        <div className="payment__section">
          <div className="payment__title">
            <h3>Delivery Address</h3>
          </div>
          {/* delivery address */}
          <div className="payment__address">
            <p>{user?.email}</p>
            <div>
              <p>Entebbe Road</p>
              <p>Bwebajja</p>
              <p>Arkright Estate, plot 56</p>
            </div>
          </div>
        </div>

        <div className="payment__section">
          <div className="payment__title">
            <h3>Review Items & Delivery</h3>
          </div>
          <div className="payment__items">
            {cart.map((item) => (
              <CheckoutPoduct
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                rating={item.rating}
              />
            ))}
          </div>
        </div>

        <div className="payment__section">
          <div className="payment__title">
            <h3>Payment Method</h3>
          </div>
          <div className="payment__details">
            {/* payment plato goes here */}

            <form onSubmit={handleSubmit}>
              <CardElement onChange={handleChange} />
              <div className="payment__priceContainer">
                <CurrencyFormat
                  renderText={(value) => (
                    <h3>
                      Order Total({cart?.length} items):
                      <strong>{value}</strong>
                    </h3>
                  )}
                  decimalScale={1}
                  thousandSeparator={true}
                  value={getCartTotal(cart)}
                  displayType={"text"}
                  prefix={"$"}
                />

                <button disabled={processing || disabled || succeeded} >
               
                  <span>
                    {processing ? <p>processing payment</p> : "Checkout"}
                  </span>

                </button>
              </div>
              {error && <div>{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment;
